/**
 * 提速插件相关
 * */
Vue.component(
    'tisu-plugin-index',
    resolve => require(["../../components/tisuPlugin/tisuPluginIndex"], resolve)
);
Vue.component(
    'tisu-plugin-setting',
    resolve => require(["../../components/tisuPlugin/tisuPluginSetting"], resolve)
);
Vue.component(
    'tisu-plugin-earning',
    resolve => require(["../../components/tisuPlugin/tisuPluginEarning"], resolve)
);
Vue.component(
    'tisu-plugin-order-record',
    resolve => require(["../../components/tisuPlugin/tisuPluginOrderRecord"], resolve)
);
Vue.component(
    'tisu-plugin-detail-record',
    resolve => require(["../../components/tisuPlugin/tisuPluginDetailRecord"], resolve)
);
Vue.component(
    'tisu-plugin-earning-detail',
    resolve => require(["../../components/tisuPlugin/tisuPluginEarningDetail"], resolve)
);
Vue.component(
    'tisu-plugin-withdraw',
    resolve => require(["../../components/tisuPlugin/tisuPluginWithdraw"], resolve)
);
Vue.component(
    'tisu-plugin-withdraw-success',
    resolve => require(["../../components/tisuPlugin/tisuPluginWithdrawSuccess"], resolve)
);
Vue.component(
    'tisu-plugin-repetition-alert',
    resolve => require(["../../components/tisuPlugin/tisuPluginRepetitionAlert"], resolve)
);
Vue.component(
    'tisu-plugin-apply',
    resolve => require(["../../components/tisuPlugin/tisuPluginApply"], resolve)
);
Vue.component(
    'tisu-plugin-apply-success',
    resolve => require(["../../components/tisuPlugin/tisuPluginApplySuccess"], resolve)
)



// WEBPACK FOOTER //
// ./resources/js/signCom/module/tisu-plugin.js